import React, { useState } from 'react'
import { DatePicker, Dropdown, Menu } from 'antd'
import { Route, Switch, useHistory, Link } from 'react-router-dom'
import moment from 'moment'
import { AiOutlineDown } from 'react-icons/ai'

import Pagination from '../../components/reusable/pagination'
import Receive from '../../components/reusable/receive'
import { useToggle, stringifyDate, useListData } from '../../modules'

import ContactGroup from '../../components/drawers/contactGroup'
import NewGroup from '../../components/drawers/newGroup'

const { RangePicker } = DatePicker

const ContactGroups = () => {
  const [ranges, setRanges] = useState();
  const [string, setString] = useState('');
  const [committed, toggleCommitted] = useToggle();

  const [
    { loading, error, fetch : fetchGroups },
    { list: groups },
    { navigate, Paginate, page = 1, limit = 10 }
  ] = useListData('contactGroups', { string }, { notify: true }, 'groups')

  const refresh = () => {
    fetchGroups ()
    navigate(1)
  }

  const search = str => {
    setString(str)
    if (str?.trim().length > 2 || str.length === 0)
    refresh()
  }

  const selectRange = range => {
    setRanges(range)
    refresh()
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
      <div className="flex justify-between items-center mt-1 mb-5">
        <input
          onChange={e => search(e.target.value)}
          className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
          id="grid-inv-item"
          type="text"
          placeholder="Search Contact Groups" />
        <span className="flex items-center">
          <RangePicker
            onChange={selectRange}
            ranges={{
              'Today': [moment().startOf('day'), moment().endOf('day')],
              'Yesterday': [moment().subtract(1, 'day').startOf('day'), moment().subtract(1, 'day').endOf('day')],
              'This Week': [moment().startOf('week'), moment().endOf('week')],
              'This Month': [moment().startOf('month'), moment().endOf('month')],
            }} />
          <Link to='/app/marketing/contact-groups/new'>
            <button className="btn ml-2 py-2.5 hisani-btn-green-light text-white">New Group</button>
          </Link>
        </span>
      </div>
      <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200 px-6 py-4">
        <header className="py-4 border-b border-gray-100 flex justify-between items-center">
          <h2 className="font-semibold text-gray-800">Contact Groups</h2>
        </header>
        <Receive
          error={error}
          loading={loading}
          progress>
          {
            groups ?
              <table className="table-auto w-full">
                {/* Table header */}
                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                  <tr>
                    <th className="p-2">
                      <div className="font-semibold text-center">No</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-left">Name</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center">Department</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center">No. of Contacts</div>
                    </th>
                    <th className="p-2">
                      <div className="font-semibold text-center"></div>
                    </th>
                  </tr>
                </thead>
                {/* Table body */}
                <tbody className="text-sm font-medium divide-y divide-gray-100">
                  {
                    groups.map((item, key) =>
                      <tr>
                        <td className="p-2">
                          <div className="text-center">{((page - 1) * limit) + key + 1}.</div>
                        </td>
                        <td className="p-2">
                          <div className="">{item?.name}</div>
                        </td>
                        <td className="p-2">
                          <div className="text-center">{item.department}</div>
                        </td>
                        <td className="p-2">
                          <div className="text-center">{item?.members?.length}</div>
                        </td>
                        <td className="p-2 text-center">
                          <Dropdown
                            overlay={
                              <Menu>
                                <Link to={`/app/marketing/contact-groups/${item._id}`}>
                                  <Menu.Item>View Group</Menu.Item>
                                </Link>
                              </Menu>
                            }>
                            <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                          </Dropdown>
                        </td>
                      </tr>
                    )
                  }
                </tbody>
              </table>
              :
              <div className="w-full h-16 flex items-center justify-center">
                <p className="font-semibold text-base">Please click above to add a new group</p>
              </div>
          }
        </Receive>
        {Paginate}
      </div>
      <Switch>
        <Route path="/app/marketing/contact-groups/new">
          <NewGroup path="/app/marketing/contact-groups" onClose={refresh} />
        </Route>
        <Route path="/app/marketing/contact-groups/:id">
          <ContactGroup path="/app/marketing/contact-groups" onClose={refresh} />
        </Route>
      </Switch>
    </div>
  );
};

export default ContactGroups;
